import { GRID_SERVICE_NAME, GridService } from '../../../../services/grid'
import { REFERENCE_TYPE_SERVICE_NAME, ReferenceTypeService } from '../../../../services/reference-type'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../../services/user-session'
import { AlarmDefinitionsController } from './alarm-definitions.controller'

//#region Asset Imports

import * as TEMPLATE from './alarm-definitions.tpl.html'

//#endregion

// #region Consts

export const COMPONENT_NAME: string = 'alarmDefinitions'

// #endregion


export class AlarmDefinitionsComponent {

    controller = [
        GRID_SERVICE_NAME,
        REFERENCE_TYPE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        (
            gridService: GridService,
            referenceTypeService: ReferenceTypeService,
            userSessionService: UserSessionService
        ) => {
            return new AlarmDefinitionsController(gridService, referenceTypeService, userSessionService)
        }
    ]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}
